// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3uq3z","notes":"Notes_notes__3v1QN","note":"Notes_note__2P9h7","markdown":"Notes_markdown__3pXLl"};